<template functional>
  <label class="form-group">
    <slot />
    <input
      type="number"
      step="1"
      :min="props.min"
      :max="props.max"
      :value="props.value"
      @keydown="$options.onKeydown($event)"
      @input="$options.onInput(listeners, props, $event)"
    >
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: undefined
    },
    max: {
      type: Number,
      default: undefined
    }
  },
  onInput (listeners, props, event) {
    const value = parseInt(event.target.value)
    if (isNaN(value)) {
      // reset if this input was not valid
      event.target.value = props.value
    } else if (props.min !== undefined && value < props.min) {
      event.target.value = props.min
      listeners.input(props.min)
    } else if (props.max !== undefined && value > props.max) {
      event.target.value = props.max
      listeners.input(props.max)
    } else {
      // emit input event
      listeners.input(value)
    }
  },
  onKeydown (event) {
    // we don't want to have any separator input
    const localSeparator = 1.1.toLocaleString().replace(/\d/g, '')
    if (event.key === localSeparator) {
      event.preventDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.form-group {
  width: 48%;
  margin-bottom: 10px;

  input {
    width: 100%;
    padding: 5px 10px;
    box-shadow: none;
    border: none;
    border-radius: 5px;
    border: 1px solid rgba($color: #fff, $alpha: 0.2);
    background: darken($color-main-darker, 2);
    color: #fff;
    font-size: 1rem;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.25pt;
    margin-top: 5px;
  }
}
</style>
